<template>
  <div class="ColumnChart">
    <GChart         
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions" />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import { numberWithDots } from '@/helpers/number'

export default {
  name: 'ColumnChart',
  components: { GChart },
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          title: 'Laadpunt behoefte',
        },
        legend: { position: 'right', textStyle: { color: '#7F7F7F' } },
        hAxis: { textStyle: { bold: true, color: '#7F7F7F' } },
        vAxis: { format: '#.###' },
        bar: { groupWidth: "80%" },
        colors: [
          '#3B547B',
          // '#689AC5'
        ],
        height: 237,
        width: 475,
        chartArea: { left: 50, right: 125 },
        focusTarget: 'category',
        animation: {
          duration: 500
        }
      }
    }
  },
  computed: {
    chartData() {
      let chartSerieLabels = [
        'Jaar', 
        '(Semi)publieke laadpunten', { role: 'annotation' },
        // 'Private laadpunten', { role: 'annotation' }
      ]
      let data = [
        chartSerieLabels
      ]

      this.data.forEach(entry => {
        data.push([
          entry[0], 
          entry[1], 
          entry[1] === 0 ? null : numberWithDots(entry[1]), 
          // entry[2], 
          // entry[2] === 0 ? null : numberWithDots(entry[2])
        ])
      })

      return data
    }
  }
}
</script>

<style>

</style>